<template>
    <div class="setting-box">
        <div class="setting-title">选项设置</div>
        <div class="setting-content">
            <div class="setting-content-item">
                <div>日期格式</div>
                <div class="type-box">
                    <el-select v-model="dataList.dateFormat" class="m-2" style="width: 100%; height: 35px" placeholder="Select" size="large">
                        <el-option v-for="item in dateTypeList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-date-setting">
const props = defineProps({
    dataList: {
        type: Object,
        default: () => ({}),
    },
});

const dateTypeList = [
    { label: "包含年月日（如2022年3月1日）", value: "D" },
    { label: "包含年月（如2022年3月）", value: "M" },
    { label: "包含年（如2022年）", value: "Y" },
];
</script>
<style lang="scss" scoped>
@import "@/css/setting.scss";
:deep(.el-radio) {
    margin-right: 60px;
}
:deep(.el-input-number) {
    width: 98px;
}
.type-box {
    display: flex;
    margin-top: 8px;
    .type-box1 {
        width: 98px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        opacity: 1;
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(229, 232, 238, 1);
        cursor: pointer;
        &:first-child {
            margin-right: 30px;
        }
    }
}

::deep(.el-select--large) {
    width: 230px;
    position: relative;
}
:deep(.el-select-dropdown__item) {
    line-height: 44px;
}
</style>
